"use client"

import { t } from "@/languages/i18n"
import { Form, Input } from "antd"
import React from "react"

export interface YouTubeVideoFormValues {
  title: string
  url: string
  videoId: string
  channelId?: string
  playlistId?: string
  channelTitle?: string
  description?: string
}

interface YouTubeVideoFormFieldsProps {
  form: any
  isEditMode: boolean
}

const YouTubeVideoFormFields: React.FC<YouTubeVideoFormFieldsProps> = ({ form, isEditMode }) => {
  return (
    <>
      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="title"
        label={<span className="text-base font-medium">{t("Title")}</span>}
        rules={[
          {
            required: true,
            message: t("Vui lòng nhập tiêu đề"),
          },
        ]}
      >
        <Input style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="url"
        label={<span className="text-base font-medium">{t("Đường dẫn")}</span>}
      >
        <Input style={{ width: "100%" }} placeholder={t("https://www.youtube.com/watch?v=...")} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="videoId"
        label={<span className="text-base font-medium">{t("Video ID")}</span>}
        rules={[
          {
            required: true,
            message: t("Vui lòng nhập ID video"),
          },
        ]}
      >
        <Input style={{ width: "100%" }} placeholder={t("youtube-video-1")} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="channelId"
        label={<span className="text-base font-medium">{t("Channel ID")}</span>}
      >
        <Input style={{ width: "100%" }} placeholder={t("Optional channel ID")} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="channelTitle"
        label={<span className="text-base font-medium">{t("Channel Title")}</span>}
      >
        <Input style={{ width: "100%" }} placeholder={t("Optional channel title")} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="playlistId"
        label={<span className="text-base font-medium">{t("ID Danh sách phát")}</span>}
        rules={[
          {
            required: true,
            message: t("Vui lòng nhập ID Danh sách phát"),
          },
        ]}
      >
        <Input style={{ width: "100%" }} placeholder="Optional playlist ID" />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="description"
        label={<span className="text-base font-medium">{t("Description")}</span>}
      >
        <Input.TextArea rows={4} style={{ width: "100%" }} placeholder={t("Optional description")} />
      </Form.Item>
    </>
  )
}

export default YouTubeVideoFormFields
